import {get, readable} from "svelte/store";

export const getTblParam = () => {
    try {
        const q = (document.location.search || '').split('?')[1] || '';
        const tbl = ((q.split('&') || []).filter(x => (x || '').indexOf('tbl=') === 0)[0] || '').split('=')[1];
        if (tbl === undefined) {
            return undefined;
        }
        return decodeURIComponent(tbl);
    }
    catch (e) {
        return undefined;
    }
}

export const replaceMask = (maskedLink, table) => {

    try {
        const m = (maskedLink || '').match(/[?&]tbl={{tbl}}/);
        if (m && m[0] && m[0][0]) {
            return maskedLink.replace(m[0], table ? `${m[0][0]}tbl=${table}` : '');
        }
        else {
            return maskedLink;
        }
    }
    catch (e) {
        return maskedLink;
    }
}

export const tableStore = readable(
    {},
    (set) => {
        const number = getTblParam();
        set ({
            enabled: number !== undefined,
            number
        });
        return () => {}
    });

export function getTable() {

    const table = get(tableStore);
    if (table.enabled === true){
        return table.number;
    }
    else {
        return undefined;
    }
}
